module.exports = __webpack_public_path__ + "img/close-1.68169784.png";